export default __webpack_public_path__ + "static/media/Group 3089.3d148662.jpg";